import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 4rem 0;
`;

export const Container = styled.div`
  background: var(--theme-color-background);
  border: solid 4px var(--theme-color-section);
  padding: 1rem 1rem 0;
  position: relative;

  &:before,
  &:after {
    background: var(--theme-color-section);
    content: ' ';
    height: 104%;
    left: -2%;
    position: absolute;
    top: -2%;
    width: 104%;
  }

  &:before {
    transform: skew(-4deg) rotate(-2deg);
    z-index: -1;
  }

  &:after {
    transform: skew(6deg) rotate(3deg);
    z-index: -2;
  }

  li {
    margin-bottom: 0.5rem;
  }
`;

export const Ratings = styled.div`
  margin-bottom: 2rem;
  @media ${(props) => props.theme.breakpoints.lg} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;
